"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParenthesisClose = void 0;
const AbstractStringElement_1 = require("./AbstractStringElement");
const ParenthesisOpen_1 = require("./ParenthesisOpen");
class ParenthesisClose extends AbstractStringElement_1.AbstractStringElement {
    static getMatcher() {
        return /^ *\) */;
    }
    getParenthesisContent() {
        return this.getOpeningParenthesis().getParenthesisContent();
    }
    getOpeningParenthesis() {
        let element = this.getPrevious();
        do {
            element = element.getPrevious();
        } while (!this.isOpeningParenthesis(element));
        return element;
    }
    isOpeningParenthesis(content) {
        return content instanceof ParenthesisOpen_1.ParenthesisOpen && content.getNestingIndex() === this.getNestingIndex();
    }
}
exports.ParenthesisClose = ParenthesisClose;
//# sourceMappingURL=ParenthesisClose.js.map